var $ = require("jquery");
var $win = $(window);

function Pager() {
    document.addEventListener("DOMContentLoaded", this._init.bind(this));
}

Pager.prototype._init = function () {

    this.pageContainer = $('.site__wrapper');
    this.pageSections = $('[data-page-section]');
    this.button = $('.pager__button');
    this.buttonNext = $('.page__skip-button');
    this.sections = $('[data-page-section]');
    this.sectionMap = [];

    this.pager;

    // Create the nav
    this._setup();

    // bind the next button click
    this.pager.find('.pager__button').on('click', this._handlePagerClick.bind(this));
    this.buttonNext.on('click', this._handleNextButtonClick.bind(this))

    this._handleResize();
    $win.on("scroll", this._handleScroll.bind(this));
    $win.on("resize", this._handleResize.bind(this));


};

Pager.prototype._handleResize = function (e) {
    var _this = this;
    this.winHeight = $win.innerHeight();

    _this.sections.each(function (i, e) {
        var $el = $(e);
        var calcTop = Math.floor($el.offset().top) + ( _this.winHeight / 3 );

        _this.sectionMap[i] = {
            el: e,
            top: calcTop
        };

    });
};

Pager.prototype._handleScroll = function (e) {
    if (!this.handlingIt) {
        this.handlingIt = true;
        window.requestAnimationFrame(this._runScroll.bind(this));
    }
};

Pager.prototype._runScroll = function (e) {
    var _this = this;

    var scrollPos = window.pageYOffset;
    var scrollBottom = Math.floor(scrollPos + _this.winHeight);

    $.each(_this.sectionMap, function (i, val) {

        if (scrollBottom > val.top) {
            $(val.el).addClass('is-in-view');

            _this.pager
                .find('.pager__button')
                .removeClass('is-current')
                .eq(i)
                .addClass('is-current');
        } else {
            $(val.el).removeClass('is-in-view');
        }
    });

    // end
    this.handlingIt = false;
};

Pager.prototype._handlePagerClick = function (e) {

    // get the item clicked
    var item = $(e.currentTarget);

    // get the index of the clicked item
    var index = item.index();

    // find the section with the same index
    var newSection = this.sections.eq(index);

    // get the position of the section
    var newPos = newSection.offset().top;

    // Animate to that section
    this.movePage(newPos);
};

Pager.prototype._handleNextButtonClick = function (e) {


    // use the next item to find the section to animate to
    var section = $(e.currentTarget).parents('.page');

    var newPos = section.offset().top + section.outerHeight();

    // Animate to that section
    this.movePage(newPos);
};


Pager.prototype.movePage = function (pos) {
    $('html, body').animate({
        scrollTop: pos
    }, 500);
};


Pager.prototype._setup = function(){
    var buttons = '';

    this.pageSections.each(function (i) {
        if ( i === 0 ) {
            buttons += '<button class="pager__button is-current">section ' + i + '</button>';
        } else {
            buttons += '<button class="pager__button">section ' + i + '</button>';
        }
    });

    this.pager = $('<div class="pager"><div class="pager__inner">'+ buttons +'</div></div>').prependTo(this.pageContainer);

};


module.exports = new Pager();


// WEBPACK FOOTER //
// ./source/assets/scripts/pager.js